import type {
  CellClassRules,
  CellRendererSelectorFunc,
  CustomCellEditorProps,
  CustomCellRendererProps,
  CustomTooltipProps,
  ISetFilterParams,
  ServerColDef,
  SetFilterValuesFunc,
  ValueFormatterFunc,
  ValueGetterFunc,
} from '@cmg/data-grid';
import { CellClassNames } from '@cmg/data-grid';
import gt from 'lodash/gt';
import lt from 'lodash/lt';

import { useEnumOptions } from '../../../../../common/hooks/useEnumOptions';
import { ParticipationReportRowFragment } from '../../graphql/__generated__/GetParticipationReportRows';

export type ParticipationReportRecord = ParticipationReportRowFragment;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- AgGrid default ColDef type defaults generic params to any
export type ParticipationReportGridColDef<TValue = any> = ServerColDef<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridCellRendererSelectorFunc<TValue> = CellRendererSelectorFunc<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridValueGetterFunc<TValue> = ValueGetterFunc<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridValueFormatterFunc<TValue> = ValueFormatterFunc<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridSetFilterValuesFunc<TValue = string> = SetFilterValuesFunc<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridCustomCellRendererProps<TValue> = CustomCellRendererProps<
  ParticipationReportRecord,
  TValue,
  ParticipationReportGridContext
>;

export type ParticipationReportGridCustomTooltipProps<TValue> = CustomTooltipProps<
  ParticipationReportRecord,
  TValue,
  ParticipationReportGridContext
>;

export type ParticipationReportGridCustomCellEditorProps<TValue> = CustomCellEditorProps<
  ParticipationReportRecord,
  TValue,
  ParticipationReportGridContext
>;

export type ParticipationReportGridSetFilterParams<TValue = string> = ISetFilterParams<
  ParticipationReportRecord,
  TValue
>;

export type ParticipationReportGridContext = Pick<ReturnType<typeof useEnumOptions>, 'sectors'>;

export const POSITIVE_NEGATIVE_VALUE_CELL_CLASS_RULES: CellClassRules<
  ParticipationReportRecord,
  number | null | undefined
> = {
  [CellClassNames.CELL_SUCCESS]: ({ value }) => gt(value, 0),
  [CellClassNames.CELL_ERROR]: ({ value }) => lt(value, 0),
} as const;
